// Months array for date formatting
const months: Array<string> = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

// Character limit for suggestion api
const suggestionApiQueryMaxlength: number = 70;

// Character limit for job search api
const jobQueryCompanyShortnameMaxlength: number = 50;

const jobQueryJobShortnameMaxlength: number = 250;

const jobSearchQueryMaxlength: number = 40;

export {
    months,
    jobQueryCompanyShortnameMaxlength,
    jobQueryJobShortnameMaxlength,
    suggestionApiQueryMaxlength,
    jobSearchQueryMaxlength,
};
